import React from 'react'
import { VideoCaptions } from '@components/Video'

interface DamVideoProperties {
  videoUrl: string
  isEditModeBoolean: boolean
  isVideoPlaying: boolean
  loopVideo: string
  hideVideoControls: string
  decorativeVideo?: string
  videoCaptions?: VideoCaptions[]
}

const DamVideo = React.forwardRef<HTMLVideoElement, DamVideoProperties>(
  (
    {
      isEditModeBoolean,
      isVideoPlaying,
      loopVideo,
      hideVideoControls,
      decorativeVideo = 'false',
      videoUrl,
      videoCaptions,
    },
    reference,
  ): JSX.Element => {
    return (
      <video
        ref={reference}
        className="cmp-video__dam-video"
        {...(isEditModeBoolean
          ? {}
          : {
              autoPlay: isVideoPlaying,
              loop: loopVideo === 'true',
              controls: hideVideoControls !== 'true' && decorativeVideo !== 'true',
            })}
        muted
        playsInline
      >
        <source src={videoUrl} type="video/mp4" />

        {videoCaptions?.map((caption, index) => (
          <track
            key={index}
            kind="captions"
            srcLang={caption.languageCode}
            src={caption.link.externalizedURL}
            label={caption.label}
            default={caption.role === 'default'}
          />
        ))}

        <span>I'm sorry; your browser doesn't support HTML5 video</span>
      </video>
    )
  },
)

export default DamVideo
